<template>
  <div class="audit-logs">
    <div class="vtm-page-head">
      <div>
        <h1 class="vtm-page-head__title">{{ $t("auditLogs.title") }}</h1>
        <div class="vtm-page-head__sub">{{ $t("auditLogs.subtitle") }}</div>
      </div>
    </div>

    <template v-if="hasAnyGrant">
      <div class="sh-seg">
        <el-radio-group v-model="hubView" size="small">
          <el-radio-button v-if="hubGrants.recharges" label="recharges">{{ $t("auditLogs.segRecharges") }}</el-radio-button>
          <el-radio-button v-if="hubGrants.wallet" label="wallet">{{ $t("auditLogs.segWallet") }}</el-radio-button>
          <el-radio-button v-if="hubGrants.account" label="account">{{ $t("auditLogs.segAccount") }}</el-radio-button>
          <el-radio-button v-if="hubGrants.billing" label="billing">{{ $t("auditLogs.segBilling") }}</el-radio-button>
          <el-radio-button v-if="hubGrants.inventory" label="inventory">{{ $t("auditLogs.segInventory") }}</el-radio-button>
          <el-radio-button v-if="hubGrants.online" label="online">{{ $t("auditLogs.segOnline") }}</el-radio-button>
        </el-radio-group>
      </div>

      <div v-show="hubView === 'recharges'" class="sh-embed"><recharge-record v-if="mounted.recharges"></recharge-record></div>
      <div v-show="hubView === 'wallet'" class="sh-embed"><wallet-record v-if="mounted.wallet"></wallet-record></div>
      <div v-show="hubView === 'account'" class="sh-embed"><wallet-account v-if="mounted.account"></wallet-account></div>
      <div v-show="hubView === 'billing'" class="sh-embed"><wallet-detail v-if="mounted.billing"></wallet-detail></div>
      <div v-show="hubView === 'inventory'" class="sh-embed"><inventory-log v-if="mounted.inventory"></inventory-log></div>
      <div v-show="hubView === 'online'" class="sh-embed"><offline-record v-if="mounted.online"></offline-record></div>
    </template>

    <div v-else class="audit-logs__empty">
      <i class="el-icon-document-remove"></i>
      <p>{{ $t("auditLogs.empty") }}</p>
    </div>
  </div>
</template>

<script>
  // 名称冲突提示：mywallet 下 Record.vue / Account.vue / Detail.vue 内部均声明 name: "Record"，
  // 此处以不同的本地别名注册（walletRecord / walletAccount / walletDetail），避免局部注册混淆。
  import rechargeRecord from "@/views/order/RechargeRecord";
  import walletRecord from "@/views/mywallet/Record";
  import walletAccount from "@/views/mywallet/Account";
  import walletDetail from "@/views/mywallet/Detail";
  import inventoryLog from "@/views/machine/user/InventoryLog";
  // 在线状态 = 后端菜单「Online Status Tracker」（OfflineRecord 设备上下线记录），不是内部的 WTI 路由器面板
  import offlineRecord from "@/views/machine/admin/OfflineRecord";
  import { grantedLinks } from "@/utils/navSections";

  // 段位显示顺序 → 默认段位取第一个已授权的
  const SEGMENT_ORDER = ["recharges", "wallet", "account", "billing", "inventory", "online"];

  export default {
    name: "AuditLogs",
    components: {
      rechargeRecord,
      walletRecord,
      walletAccount,
      walletDetail,
      inventoryLog,
      offlineRecord
    },
    data() {
      return {
        hubView: "",
        // 首次访问才挂载对应旧页面，此后用 v-show 保留状态（无 echarts-by-id 图表，无需销毁重建）
        mounted: {
          recharges: false,
          wallet: false,
          account: false,
          billing: false,
          inventory: false,
          online: false
        }
      };
    },
    computed: {
      // 各分段对应的旧页面授权（子账号可能仅被授予部分页面）
      hubGrants() {
        const g = grantedLinks(this.$store.state.menuList);
        return {
          recharges: g.has("/order/recharge-record"),
          wallet: g.has("/mywallet/record"),
          account: g.has("/mywallet/account"),
          billing: g.has("/mywallet/detail"),
          inventory: g.has("/machine/user/inventory-log"),
          online: g.has("/machine/admin/offline-record")
        };
      },
      hasAnyGrant() {
        return Object.keys(this.hubGrants).some(key => this.hubGrants[key]);
      }
    },
    created() {
      const first = SEGMENT_ORDER.find(key => this.hubGrants[key]);
      if (first) {
        this.hubView = first;
        this.mounted[first] = true;
      }
    },
    watch: {
      hubView(v) {
        if (v && Object.prototype.hasOwnProperty.call(this.mounted, v)) {
          this.mounted[v] = true;
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .sh-seg {
    padding: 10px 16px 8px;
  }
  .sh-embed {
    overflow-x: auto;
  }
  .audit-logs__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    color: var(--vtm-ink-3);

    i {
      font-size: 42px;
      margin-bottom: 12px;
    }

    p {
      margin: 0;
      font-size: 13.5px;
    }
  }
</style>
